import { PersonaAvatar } from './PersonaAvatar';
import type { PersonaType } from '../api/projects';

interface TypingDotsProps {
  roleName: string;
  persona: PersonaType | undefined;
}

export function TypingDots({ roleName, persona }: TypingDotsProps) {
  return (
    <div className="typing-dots" aria-live="polite">
      <PersonaAvatar persona={persona} roleName={roleName} size={40} showBadge={false} />
      <div className="typing-dots-bubble">
        <span className="typing-text">{roleName} yazıyor…</span>
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
      </div>
    </div>
  );
}
